(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
window.addEventListener('load', () => {
	let about = document.querySelector('.about'),
		img = document.querySelector('.about-img'),
		timeout;

	function resize() {
		if (timeout) {
			clearTimeout(timeout);
		}
		img.style.height = about.clientHeight + 'px';
		timeout = setTimeout(() => {
			img.style.height = about.clientHeight + 'px';	
		}, 200);
	}

	window.addEventListener('resize', resize);
	setTimeout(() => {
		resize();	
	}, .5e3);
});
},{}],2:[function(require,module,exports){
class Animation {
	constructor() {
		this.items = document.querySelectorAll('[data-animation]');
		setTimeout(() => {
			document.addEventListener('scroll', this.test.bind(this));
			document.addEventListener('resize', this.test.bind(this));
			this.test();
		}, .5e3);
	}
	
	test() {
		for(let i = 0 ; i<this.items.length ; i++) {
			let item  = this.items[i];
			let rect = item.getBoundingClientRect();
			item.setAttribute (
				'data-in-viewport',
				rect.top < document.body.clientHeight || rect.top < 0
			);
		}
	}
}

window.addEventListener('load', () => {
	new Animation();
});
},{}],3:[function(require,module,exports){
const Form = require('./form');

$(() => {
	new Form($('.js-apply'));
});
},{"./form":6}],4:[function(require,module,exports){
$(()=>{
   $('.faqList-title').click(function() {
      $(this).parents('.faqList-item').find('.faqList-body').slideToggle(200);
   });
});
},{}],5:[function(require,module,exports){
class File {
	constructor(obj) {
		let btn = obj.find('.file-btn'),
			input = obj.find('.file-input'),
			value = obj.find('.file-value');
		
		input.change(() => {
			value.text(input.val().replace(/^.*([\/\\])([\w.]+)$/, '$2'));
		});
		
		btn.click((e) => {
			e.preventDefault();
			input.click();
		});
	}
}

$(() => {
	$(".file").each(function () {
		new File($(this));
	});
});
},{}],6:[function(require,module,exports){
class Form {
	constructor(obj) {
		this.init = obj.find('.form-state_init');
		this.success = obj.find('.form-state_success');
		this.form = obj.find('form');
		this.btn = obj.find('.js-apply-btn');
		this.mandatoryInputs = obj.find('.form-input_mandatory input');
		this.mandatoryInputsArr = this.mandatoryInputs.get().map(e => $(e));
		this.mandatoryInputs.keydown(function () {
			$(this).removeClass('form-input_error')
		})
		
		this.form.submit(this.submit.bind(this));
	}

	check() {
		let errors = [];
		this.mandatoryInputs.removeClass('form-input_error');
		for (let i = 0; i < this.mandatoryInputs.length; i++) {
			if (this.mandatoryInputsArr[i].val().length < 1) {
				void this.mandatoryInputsArr[i][0].offsetWidth;
				this.mandatoryInputsArr[i].addClass('form-input_error');
				errors.push(this.mandatoryInputsArr[i]);
			}
		}

		return errors.length ? errors : false;
	}

	submit(e) {
		e.preventDefault();
		if (this.check() !== false) {
			return false;
		}
		this.btn.addClass('_sending');
		
		$.ajax({
			url: '/api.php',
			type: 'post',
			data: new FormData(this.form[0]),
			cache: false,
			contentType: false,
			processData: false,
			success: (data) => {
				this.btn.removeClass('_sending');
				if (data === 'success') {
					this.init.slideToggle(200);
					this.success.slideToggle(200);
				} else {
					alert('Something went wrong, please try again later');
				}
			}
		})
	}
}

module.exports = Form;
},{}],7:[function(require,module,exports){
window.addEventListener('DOMContentLoaded', () => {
	let header = document.querySelector('.header');
	let state = false;
	
	function scroll() {
		let newState = (window.scrollY > 50);
		if (newState !== state) {
			if (newState) {
				header.classList.add('header_dark');
			} else {
				header.classList.remove('header_dark');
			}
			
			state = newState;
		}
	}
	
	document.addEventListener('scroll', scroll);
	scroll();
});
},{}],8:[function(require,module,exports){
class Menu {
	constructor(obj) {
		this.holder = obj;
		this.items = document.querySelectorAll('*[data-name]');

		document.addEventListener('scroll', this.test.bind(this));
		document.addEventListener('resize', this.test.bind(this));
		this.test();

		document.querySelectorAll('.js-scroll-to').forEach(item => {
			item.addEventListener('click', (e) => {
				this.scrollTo(e.currentTarget.getAttribute('href').replace(/^.*#/, ''));
			});
		});
		
		if (document.location.hash) {
			this.scrollTo(document.location.hash.replace(/^.*#/, ''));
		}
	}

	scrollTo(name) {
		let yOffset = 100;
		let element = document.querySelector('[data-name="' + name + '"]');
		console.log('[data-name="' + name + '"]');
		if (element) {
			let y = element.getBoundingClientRect().top + window.pageYOffset - yOffset;
			window.scrollTo({top: y, behavior: 'smooth'});
		}
	}

	test() {
		for (let i = 0; i < this.items.length; i++) {
			let item = this.items[i];
			let rect = item.getBoundingClientRect();
			if (
				rect.top < window.innerHeight * .6 &&
				rect.top + (rect.bottom - rect.top) * .6 > 0
			) {
				this.setCurrent(item.getAttribute('data-name'));
			} else {
				this.unsetCurrent(item.getAttribute('data-name'));
			}
		}
	}

	setCurrent(name) {
		this.unsetCurrent();

		let link = this.holder.querySelector('.menu-item[href$="#' + name + '"]');
		if (link) {
			link.classList.add('menu-item_current');
		}
	}

	unsetCurrent(name) {
		let current = this.holder.querySelector(name ? '.menu-item[href$="#' + name + '"]' : '.menu-item_current');
		if (current) {
			current.classList.remove('menu-item_current');
		}
	}
}

window.addEventListener('load', () => {
	if ($('.page.main').length) {
		new Menu(document.querySelector('.menu'));
	}
});
},{}],9:[function(require,module,exports){
(function () {
	let visible = false;
	let menu = document.querySelector('.menu');
	let burger = document.querySelector('.burger');
	
	function show() {
		menu.classList.add('menu_visible');
		burger.classList.add('burger_open');
		visible = true;
	}
	
	function hide() {
		menu.classList.remove('menu_visible');
		burger.classList.remove('burger_open');
		visible = false;
	}
	
	burger.addEventListener('click', function (e) {
		e.stopPropagation();
		visible ? hide() : show();
	});
	
	window.addEventListener('click', hide);
})();
},{}],10:[function(require,module,exports){
require('./block/animation.js');
require('./block/menu.js');
require('./block/mobileMenu');
require('./block/apply');
require('./block/file');
require('./block/about');
require('./block/header');
require('./block/faq');

$(function () {
	$('.js-header').each(function () {
		let obj = $(this);
		let text = obj.text().trim().split(' ');
		text = text.map(t => '<span>' + t + '</span>');
		obj.html(text.join(' '));
	});
});
},{"./block/about":1,"./block/animation.js":2,"./block/apply":3,"./block/faq":4,"./block/file":5,"./block/header":7,"./block/menu.js":8,"./block/mobileMenu":9}]},{},[10])

